import React, { useState, useRef, useEffect } from 'react';
import Transition from '../utils/Transition';

function DropdownFilter({ align, selectedFilters, onFilterChange }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const trigger = useRef(null);
  const dropdown = useRef(null);

  // Close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // Close if the ESC key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  const getStatusEmoji = (status) => {
    const emojiMap = {
      draft: '📝',
      ready: '⚡',
      live: '🔥',
      complete: '✅'
    };
    return emojiMap[status] || '📋';
  };

  return (
    <div className="relative flex w-full" style={{fontFamily: '"Share Tech Mono", monospace'}}>
      <button
        ref={trigger}
        className="px-3 py-3 rounded-md flex items-center justify-center gap-2 font-bold text-sm transition-all duration-100 w-full"
        style={{
          background: 'rgba(52, 73, 94, 0.6)',
          border: '1px solid rgba(241, 196, 15, 0.4)',
          color: '#ECF0F1'
        }}
        aria-haspopup="true"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-expanded={dropdownOpen}
      >
        <span className="sr-only">Filter</span>
        <span>🔧 FILTER</span>
      </button>

      <Transition
        show={dropdownOpen}
        tag="div"
        className={`origin-top-right z-[9999] absolute top-full left-0 right-auto min-w-[12rem] rounded-lg shadow-xl overflow-hidden mt-2 ${
          align === 'right' ? 'md:left-auto md:right-0' : 'md:left-0 md:right-auto'
        }`}
        style={{
          background: '#1A252F',
          border: '2px solid #F1C40F',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.9)'
        }}
        enter="transition ease-out duration-200 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div ref={dropdown} className="px-4 pb-4 rounded-lg" style={{background: '#1A252F'}}>
          <div className="text-xs font-black tracking-wider uppercase pt-3 pb-2" style={{color: '#F1C40F'}}>
            🎯 FILTERS
          </div>
          <ul className="mb-0">
            {Object.keys(selectedFilters).map((status) => (
              <li key={status} className="py-2">
                <label className="flex items-center cursor-pointer">
                  {/* Custom Rounded Checkbox */}
                  <input
                    type="checkbox"
                    className="rounded-full h-4 w-4 transition-all duration-100"
                    style={{
                      backgroundColor: selectedFilters[status] ? '#F1C40F' : 'rgba(52, 73, 94, 0.6)',
                      borderColor: '#F1C40F',
                      borderWidth: '2px'
                    }}
                    checked={selectedFilters[status]}
                    onChange={() => onFilterChange(status)}
                  />
                  <span className="text-sm font-bold ml-3 capitalize flex items-center gap-2" style={{color: '#ECF0F1'}}>
                    {getStatusEmoji(status)} {status.toUpperCase()}
                  </span>
                </label>
              </li>
            ))}
          </ul>
        </div>
      </Transition>
    </div>
  );
}

export default DropdownFilter;